enum WorkflowCodeEnum {
    REDIRECT = "REDIRECT"
}

export default WorkflowCodeEnum;
